<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'sidebar',
})
</script>
<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-28 16:17:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 17:20:08
 * @FilePath: /qd-c4-yunjing-web/src/layouts/components/sidebar/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 侧边导航
-->
<template>
  <section class="sidebar">
    <logo />
    <el-scrollbar wrap-class="sidebar-list">
      <sidebar-item
        v-if="$route.path !== '/error/401'"
        :permission-routes="permissionRoutes"
        :active-menu="activeMenu"
        @setCollapse="(val)=>changeCollapse(val)"
        @to-blank="handleToBlank"
      />
    </el-scrollbar>
    <div class="sidebar-bottom">
      <el-icon
        class="sidebar-bottom-icon"
        @click="changeCollapse(true)"
      >
        <fold
          v-if="isCollapse"
          :size="30"
        />
        <expand
          v-else
          :size="30"
        />
      </el-icon>
    </div>
  </section>
</template>
<script lang="ts" setup name="sidebar">
  import {
    computed, onMounted, ref, watch,
  } from 'vue';
  import { Fold, Expand } from '@element-plus/icons-vue';
  import { useOrgStore } from '@/store/org';
  import Logo from '../logo/index.vue';
  import SidebarItem from './sidebar-item.vue';

  const props = defineProps({
    permissionRoutes: {
      type: Array<any>,
      default: [],
    },
    activeMenu: {
      type: String,
      default: '',
    },
  });
  const emit = defineEmits(['collapse', 'to-blank']);
  const isCollapse = ref(true);
  const orgStore = useOrgStore();
  const orgActiveMenu = computed(() => orgStore.activeMenu);

  const changeCollapse = (val:boolean) => {
    if (val) {
      isCollapse.value = !isCollapse.value;
    } else {
      isCollapse.value = true;
    }
    console.log('val', val);
    /*
     * console.log('orgActiveMenu.value', orgActiveMenu.value);
     * console.log('props.activeMenu', props.activeMenu);
     * if (orgActiveMenu.value === props.activeMenu) {
     *   isCollapse.value = !isCollapse.value;
     * } else {
     *   orgStore.setActiveMenu(props.activeMenu);
     *   isCollapse.value = true;
     * }
     * isCollapse.value = !isCollapse.value;
     */
    emit('collapse', isCollapse.value);
  };
  const handleToBlank = (info: TypeObject) => {
    emit('to-blank', info);
  };
  onMounted(() => {
  });
</script>

<style lang="scss" scoped>
  .sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: var(--maia-aside-width) !important;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  // background: rgba(255, 255, 255, 0.1);
  background: linear-gradient(90deg, rgba(145, 191, 238, 0.6), rgba(237, 246, 255, 0.6)),
    linear-gradient(0deg, rgba(144, 188, 236, 0) 7.47%, rgba(240, 243, 246, 0.14) 83.66%);
  box-shadow: 2px 1px 12px 8px rgba(30, 49, 72, 0.15);
  backdrop-filter: blur(4px);

  .sidebar-list {
    display: flex;
    height: calc(100vh - 200px);
  }

  .sidebar-bottom{
    position: absolute;
    right: 10px;
    bottom: 16px;

    .sidebar-bottom-icon{
      color: rgb(116, 131, 147);
      font-size: 30px;
    }
  }
}

@media screen and (max-height: 768px) {
  .sidebar-bottom{
    display: none;
  }
}
</style>
